export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/property-insurance.054894d6.svg","height":360,"width":462};